import React, { useState, useContext, useCallback } from 'react';
import {
  string as stringType,
  arrayOf,
  shape as shapeType,
  bool as boolType,
  func,
  objectOf,
} from 'prop-types';
import './endcap.scss';
import { Tab, Tabs } from '@thd-olt-component-react/core-ui';

const CategoryTabs = ({
  categories,
  endCapData,
  nameOfEventAttribute = 'Model2',
  channel,
  title,
  handleTabClick,
}) => {
  const [value, setValue] = useState(0);
  const onChange = ({ index }) => {
    setValue(index);
  };
  const changeActiveIndex = useCallback((newIndex) => {
    setValue(newIndex);
  }, []);

  return (
    <Tabs
      gridStyle
      parentId="digital-endcap-tabs"
      value={value}
      onChange={onChange}
    >
      {(categories || []).map((category, categoryIndex) => (
        <Tab
          key={categoryIndex}
          label={category.category}
          value={categoryIndex}
          onClick={(ev) => handleTabClick(
            ev,
            categoryIndex,
            category.nValue,
            nameOfEventAttribute,
            changeActiveIndex
          )}
        />
      ))}
    </Tabs>
  );
};

CategoryTabs.propTypes = {
  categories: arrayOf(
    shapeType({
      category: stringType,
      nValue: stringType,
      imageUrl: stringType,
      url: stringType,
      shopAllLink: stringType,
      exclude: arrayOf(stringType),
      displayImageOnMobileWeb: boolType,
    })
  ),
  endCapData: objectOf(
    shapeType({
      products: arrayOf(stringType),
    })
  ),
  nameOfEventAttribute: stringType,
  channel: stringType,
  title: stringType,
  handleTabClick: func,
};

CategoryTabs.defaultProps = {
  categories: [],
  nameOfEventAttribute: '',
  channel: '',
  title: '',
  handleTabClick: func,
  endCapData: {},
};

export { CategoryTabs };
